import { combineReducers } from 'redux';

import app from './app';
import attendance from './attendance';
import callMe from './callMe';
import cart from './cart';
import category from './category';
import checkout from './checkout';
import contact from './contact';
import creditCard from './creditCard';
import customer from './customer';
import delivery from './delivery';
import freights from './freights';
import global from './global';
import landigpage from './landingpage';
import localization from './localization';
import product from './product';
import publications from './publications';
import recommendations from './recommendations';
import search from './search';
import sitemap from './sitemap';
import stores from './stores';
import totem from './totem';
import whatsApp from './whatsApp';

// MANTER A STORE EM ORDER ALFABÉTICA.
const reducers = combineReducers({
  global,
  app,
  attendance,
  callMe,
  cart,
  category,
  checkout,
  contact,
  customer,
  creditCard,
  delivery,
  freights,
  landigpage,
  localization,
  product,
  publications,
  recommendations,
  search,
  sitemap,
  stores,
  totem,
  whatsApp,
});

export default reducers;
